<div class="toggle-switch" [ngClass]="{ 'toggle-switch--checked': checked }">
  <div class="toggle-switch__field">
    <input
      class="switch-input peer"
      type="checkbox"
      [id]="label()"
      [disabled]="disabled"
      [checked]="checked"
      (change)="setCheckedState(!checked)" />
    <span class="switch-icon"></span>
  </div>

  <label
    class="toggle-switch__label"
    [ngClass]="labelClasses()"
    [for]="label()">
    @if (!!labelIcon()) {
      @if (labelIcon() === 'blue-verify') {
        <img
          class="toggle-switch__icon"
          ngSrc="assets/icons/verify.svg"
          width="20"
          height="20"
          alt="verify" />
      } @else if (labelIcon() === 'golden-verify') {
        <img
          class="toggle-switch__icon"
          ngSrc="assets/icons/golden-verify.svg"
          width="20"
          height="20"
          alt="verify" />
      } @else {
        <i
          class="iconsax"
          [ngClass]="labelIconClasses()"
          [attr.icon-name]="labelIcon()"></i>
      }
    }

    {{ label() | translate }}
  </label>
</div>
